const MACHINE_URL = {
    dev: "https://dev-machineapp.tipico.com",
    staging: "staging-machineapp",
    production: "https://d1c2u1ii08q0n6.cloudfront.net"
};

declare let JACKTIME_SRC: string;

const JACKTIME_HISTORY_SOURCE = {
    dev: JACKTIME_SRC,
    production: "https://api.tipico.com/v1/bet-cashout-history",
    staging:
        "https://eks-s-staging.staging.irl.aws.tipicodev.com/v1/bet-cashout-history"
};

function geJacktimetHistorySource() {
    const currentUrl = window.location.href;

    if (currentUrl.includes(MACHINE_URL.production)) {
        return JACKTIME_HISTORY_SOURCE.production;
    } else if (currentUrl.includes(MACHINE_URL.dev)) {
        return JACKTIME_HISTORY_SOURCE.dev;
    } else if (currentUrl.includes(MACHINE_URL.staging)) {
        return JACKTIME_HISTORY_SOURCE.staging;
    }
    return JACKTIME_HISTORY_SOURCE.production;
}

export const JACKTIME_HISTORY_URL = geJacktimetHistorySource();
